import { createQuery } from 'react-query-kit';

import * as Types from '../api/reports/types.api';
import * as API from '../api/reports/index.api';

//
//

const key = 'reports';

//

export const useQueryImpactStatsGet = createQuery<
  Types.ImpactStatsResponse,
  Types.ImpactStatsQueryParams
>({
  queryKey: [key, 'impact-range'],
  fetcher: (params) => API.getImpactStatsAPI(params),
});

//

export const useQueryCumulativeImpactStatsGet = createQuery<
  Types.ImpactStatsResponse,
  Types.ImpactStatsQueryParams
>({
  queryKey: [key, 'impact-cumulative'],
  fetcher: (params) => API.getImpactStatsAPI(params),
});

//

export const useQueryReportsPurchasesByMerchantList = createQuery<
  Types.PurchasesByMerchantResponse,
  Types.PurchasesByMerchantQueryParams
>({
  queryKey: [key, 'purchases-by-merchant'],
  fetcher: (params) => API.getPurchasesByMerchantCodeAPI(params),
});
